const AlarmsAndWarningsReport = () => import(/* webpackChunkName: "alarmsAndWarningsReportView" */ '@/app/generalPanel/reports/alarmsAndWarnings/ReportView');
const AssetRelationReportView = () => import(/* webpackChunkName: "assetsRelationReport" */ '@/app/generalPanel/reports/assetsRelation/ReportView');
const ChromatographyGraphPrint = () => import(/* webpackChunkName: "chromatographyPrint" */ '@/app/installation/engineering/modules/chromatography/print');
const CleanViewPanel = () => import(/* webpackChunkName: "cleanViewPanel" */ '../index');
const ComparativeAnalysisTablePrint = () => import(/* webpackChunkName: "comparativeAnalysis" */ '@/app/installation/engineering/modules/chromatography/methodsAndDiagnostics/comparativeAnalysis/tableView/PrintView');
const DiagnosticsHistory = () => import(/* webpackChunkName: "diagnosticsHistoryReport" */ '@/app/generalPanel/reports/diagnosticsHistory/ReportView');
const HistoryDataReport = () => import(/* webpackChunkName: "dataHistoryReport" */ '@/app/generalPanel/reports/dataHistory/report');
const IndividualAnalysisPrint = () => import(/* webpackChunkName: "individualAnalysisPrint" */ '@/app/installation/engineering/modules/chromatography/methodsAndDiagnostics/individualAnalysis/print');
const LatestManeuversMoreDetails = () => import(/* webpackChunkName: "latestManeuversMoreDetails" */ '@/app/installation/supervision/sensors/latestManeuvers/MoreDetails');
const MethodsAndDiagnostics = () => import(/* webpackChunkName: "chromatographyMethodsAndDiagnostics" */ '@/app/installation/engineering/modules/chromatography/methodsAndDiagnostics');
const NetworkStatusReport = () => import(/* webpackChunkName: "networkStatusReport" */ '@/app/generalPanel/reports/networkStatusHistory/ReportView');
const OscillographyReport = () => import(/* webpackChunkName: "oscillographyReport" */ '@/app/generalPanel/reports/oscillography/ViewReport');
const PhysicalChemicalReportPrint = () => import(/* webpackChunkName: "physicalChemicalPrint" */ '@/app/installation/engineering/modules/physicalChemical/print');
const Reports = () => import(/* webpackChunkName: "physicalChemicalReport" */ '@/app/installation/engineering/modules/physicalChemical/reports');
const OperationsHistoryReport = () => import(/* webpackChunkName: "operationsHistoryReport" */ '@/app/generalPanel/reports/operationsHistory/ReportView');
const LoadSimulationReport = () => import(/* webpackChunkName: "loadSimulationReport" */ '@/app/generalPanel/reports/loadSimulation/report/index');

export default {
  path: '',
  name: 'clean-view',
  component: CleanViewPanel,
  children: [
    {
      path: 'relatorios/historico-operacoes/visualizar',
      component: OperationsHistoryReport,
      name: 'clean-view.operations-history.view-report',
      meta: {
        breadcrumb: { name: 'page-name.operations-history' },
        permissions: ['PER022'],
      },
    },
    {
      path: 'relatorios/alarmes-e-avisos/visualizar',
      component: AlarmsAndWarningsReport,
      name: 'clean-view.alarms-and-warnings.view-report',
      meta: {
        breadcrumb: { name: 'page-name.alarms-and-warnings' },
        permissions: ['PER025'],
      },
    },
    {
      path: 'relatorios/status-de-rede/visualizar',
      component: NetworkStatusReport,
      name: 'clean-view.network-status-report.view-report',
      meta: {
        breadcrumb: { name: 'page-name.network-status-report' },
      },
    },
    {
      path: 'relatorios/oscilografia/visualizar/:reportId',
      component: OscillographyReport,
      name: 'clean-view.oscillography.view-report',
      meta: {
        permissions: ['PER024'],
      },
    },
    {
      path: 'relatorios/historico-dados/visualizar/:reportId',
      component: HistoryDataReport,
      props: true,
      name: 'clean-view.data-history.view-report',
      meta: {
        breadcrumb: { name: 'page-name.data-history' },
        permissions: ['PER023'],
      },
    },
    {
      path: 'instalacao/supervisao/sensor/:sensorId/manobra/:maneuverType',
      component: LatestManeuversMoreDetails,
      props: true,
      name: 'clean-view.sensors.latest-maneuvers-more-details',
    },
    {
      path: 'instalacao/:installationId/engenharia/:assetId/modulo/:assetModuleId/laudos',
      component: Reports,
      props: true,
      name: 'clean-view.physical-chemical-lots-and-parameters',
      meta: {
        breadcrumb: { name: 'page-name.diagnosis' },
      },
    },
    {
      path: 'relatorios/relacao-ativos/visualizar/',
      component: AssetRelationReportView,
      name: 'clean-view.assets-relation.view-report',
      meta: {
        breadcrumb: { name: 'page-name.asset-relation' },
        permissions: ['PER026'],
      },
    },
    {
      path: 'relatorios/relacao-diagnosticos/visualizar/',
      component: DiagnosticsHistory,
      name: 'clean-view.diagnostics-history.view-report',
      meta: {
        breadcrumb: { name: 'page-name.diagnostics-history' },
        permissions: ['PER027'],
      },
    },
    {
      path: 'instalacao/:installationId/engenharia/:assetId/modulo/:assetModuleId/laudos/:sampleId/impressao',
      component: PhysicalChemicalReportPrint,
      props: true,
      name: 'clean-view.physical-chemical-lots-and-parameters.print',
    },
    {
      path: 'instalacao/:installationId/engenharia/:assetId/modulo/:assetModuleId/graficos/impressao',
      component: ChromatographyGraphPrint,
      props: route => (
        {
          sampleIds: route.query.sampleIds,
          assetModuleId: route.params.assetModuleId,
        }),
      name: 'clean-view.chromatography-graph.print',
    },
    {
      path: 'instalacao/:installationId/engenharia/:assetId/modulo/:assetModuleId/metodos-e-dianosticos',
      component: MethodsAndDiagnostics,
      props: true,
      name: 'clean-view.chromatography.methods-and-diagnostics',
      meta: {
        breadcrumb: { name: 'page-name.methods-and-diagnostics' },
      },
    },
    {
      props: true,
      path: 'instalacao/:installationId/engenharia/:assetId/modulo/:assetModuleId/metodos-e-diagnosticos/analise-individual/:sampleId/impressao',
      component: IndividualAnalysisPrint,
      name: 'clean-view.chromatography.methods-and-diagnostics.individual-analysis.print',
    },
    {
      path: 'instalacao/:installationId/engenharia/:assetId/modulo/:assetModuleId/metodos-e-dianosticos/analise-comparativa/tabela/impressao',
      component: ComparativeAnalysisTablePrint,
      props: true,
      name: 'clean-view.chromatography.methods-and-diagnostics.comparative-analysis-table.print',
    },
    {
      path: 'instalacao/:installationId/engenharia/:assetModuleId/simulacao-carga/resultado/:resultId',
      component: LoadSimulationReport,
      props: true,
      name: 'clean-view.load-simulation.simulation-result',
      meta: {
        breadcrumb: { name: 'reports.load-simulation.title' },
      },
    },
  ],
};
